import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "store/store";
import Jumbotron from "components/Jumbotron/Jumbotron";
import { locationsSelector, fetchLocations, clearState } from "features/locations/locations.slice";

import './LocationsComponent.scss';
import LocationsCard from "../LocationsCard/LocationsCard";
import { setToastState } from "components/Toast/Toast.slice";
import ScrollToTop from "components/ScrollToTop/ScrollToTop";
import { Context } from "components/app/Wrapper";
import { DirectionCheck } from "utils/classnameSwitch";
import { Helmet } from "react-helmet";

const LocationsComponent: React.FC = () => {
    const { t } = useTranslation();
    const context: any = useContext(Context); 
    const dispatch = useAppDispatch();
    const { isSuccess, isError, errorMessage, locationList } = useAppSelector(locationsSelector);
    
    useEffect(() => 
      dispatch(fetchLocations())
    , [dispatch, context.locale]);

    useEffect(() => {
      if (isError) {
        dispatch(setToastState({type: 'danger', message: errorMessage, dismiss: 3500}));
        dispatch(clearState());
      }
    }, [isError, dispatch, errorMessage]);
    
    return (
      <>
        <Helmet>
          <title>Vacation Home Rentals Dubai | Best Locations near Staycae</title>
          <meta name='description' content="From beachside bliss to urban energy; find your ideal vacation home rentals in Dubai in one of our prime locations and enjoy an incredible city escape." />
          <meta name='keywords' content="vacation home rentals dubai, prime vacation home rentals near dubai malls, vacation home rentals with easy public transport access, family-friendly staycation home rentals in dubai, affordable vacation home rentals close to restaurants, home rentals in dubai with scenic views, popular holiday home rentals for tourists, home rentals in urban and beachside locations, dubai" />
        </Helmet>
        <div className="locations" dir={DirectionCheck()}>
          <Jumbotron
            title={t('location.title')}
            subtitle1={t('location.subtitle1')}
            subtitle2={t('location.subtitle2')}
            classes="service-jt"
          ></Jumbotron>
          <div className="grid">
            <p className="locations-heading">{t('location.heading')}</p>
            <div className="locations-card-wrapper">
              {isSuccess ? locationList.map(location => <LocationsCard {...location} />) : null}
            </div>
          </div>
          <ScrollToTop refID="" />
        </div>
      </>
    );
}

export default LocationsComponent;
